import { render } from "./PhotoOptionCarousel.vue?vue&type=template&id=7440644b&scoped=true&ts=true"
import script from "./PhotoOptionCarousel.vue?vue&type=script&lang=ts"
export * from "./PhotoOptionCarousel.vue?vue&type=script&lang=ts"

import "./PhotoOptionCarousel.vue?vue&type=style&index=0&id=7440644b&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7440644b"]])

export default __exports__